import React, { useState } from 'react'
import { Layers, ZoomIn } from 'lucide-react'
import Lightbox from '../../components/Lightbox'

// ACF field 'deck_plan' — single image URL (Return Format: URL)
// headingHidden: true khi heading được render bởi parent block
export default function DeckPlan({ deckPlan, headingHidden }) {
  const imageUrl = typeof deckPlan === 'string' ? deckPlan : deckPlan?.url ?? null
  const [open, setOpen] = useState(false)

  return (
    <div>
      {!headingHidden && (
        <>
          <h2 className="ljn-section-title">Deck Plan</h2>
          <div className="ljn-divider" style={{ marginBottom: 32 }} />
        </>
      )}

      <div className="sc-deck-plan__image">
        {imageUrl ? (
          <div className="sc-deck-plan__clickable" onClick={() => setOpen(true)}>
            <img src={imageUrl} alt="Deck plan" />
            <div className="sc-deck-plan__zoom-hint">
              <ZoomIn size={18} strokeWidth={1.5} />
              <span>Click to enlarge</span>
            </div>
          </div>
        ) : (
          <div className="sc-deck-plan__placeholder">
            <Layers size={48} strokeWidth={1} />
            <p>Deck plan image coming soon</p>
          </div>
        )}
      </div>

      {open && imageUrl && (
        <Lightbox
          images={[imageUrl]}
          startIdx={0}
          caption="Deck Plan"
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  )
}
